import { makeStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles<Theme>((theme) => ({
  input: {
    border: '1px solid rgba(0, 0, 0, 0.38)',
    borderRadius: '8px',
    minHeight: 104,
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.38)',
    },
    '& fieldset': { border: 'none' },
  },
  alert: {
    background: theme.palette.error.light,
    borderRadius: '8px',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      borderLeft: `8px solid ${theme.palette.error.main}`,
    },
  },
  alertLabel: {
    paddingLeft: theme.spacing(2),
  },
}))

export default useStyles
